import { collectErrorMessages, getErrorMessageFromUnknown } from "@/api/getApiErrorMessage";
import { notifications } from "@mantine/notifications";

/**
 * Shows error notifications based on the error type.
 * If the error contains multiple messages (array), shows each as a separate notification.
 * Otherwise, shows a single notification with the error message.
 */
export const showErrorNotification = (
  error: unknown,
  title: string = "오류",
  defaultMessage: string = "알 수 없는 오류가 발생했습니다"
) => {
  let messages: string[] = [];

  if (error instanceof Error) {
    try {
      messages = collectErrorMessages(JSON.parse(error.message));
    } catch {
      messages = error.message ? error.message.split("\n") : [];
    }
  } else {
    messages = collectErrorMessages(error);
  }

  if (messages.length === 0) {
    messages = [getErrorMessageFromUnknown(error, defaultMessage)];
  }

  // Show notifications for each message
  messages.forEach((message, index) => {
    notifications.show({
      title: messages.length > 1 ? `${title} (${index + 1}/${messages.length})` : title,
      message,
      color: "red",
    });
  });
};

/**
 * Shows a success notification
 */
export const showSuccessNotification = (title: string, message: string) => {
  notifications.show({
    title,
    message,
    color: "green",
  });
};

/**
 * Shows a warning notification
 */
export const showWarningNotification = (title: string, message: string) => {
  notifications.show({
    title,
    message,
    color: "yellow",
  });
};
